<!-- Form input for selecting a gender via a radio button group. -->

<script lang="ts">
import { getRadioGroupEmits, getRadioGroupProps } from '@nzyme/vue-forms/components/useRadioGroup.js';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import { useEmitAsProps } from '@nzyme/vue-utils/useEmitAsProps.js';

import { Gender, GenderTranslation } from '@sigma/common/models/Gender.js';

import ButtonRadio from './ButtonRadio.vue';
import * as l from './GenderInput.loc.js';
import RadioGroup from './RadioGroup.vue';
</script>

<script lang="ts" setup>
defineProps(getRadioGroupProps<Gender>());
defineEmits(getRadioGroupEmits<Gender>());
const emits = useEmitAsProps();
const t = useTranslate();
</script>

<template>
  <RadioGroup
    :label="t(l.genderLabel)"
    :inner-class="css.options"
    v-bind="{ ...emits, ...$props }"
  >
    <ButtonRadio
      v-for="option in Gender.options"
      :key="option"
      :value="option"
      :class="css.option"
    >
      {{ t(GenderTranslation, option) }}
    </ButtonRadio>
  </RadioGroup>
</template>

<style lang="scss" module="css">
.noBorderInputGroup {
  border: none;
}

.options {
  align-items: center;
  display: flex;
  flex: 1;
  padding: 0 $spacing-08;
  gap: $spacing-08;
  padding: 0;
}

.option {
  height: $input-height;
  flex: 1;
}
</style>
